/*
EllipsisModal - Modal based text viewer
@author Arsena 'senndbx', 2019

Format:
  <EllipsisModal type={} descriptor={} name={} description={} />

Props used:
  - type: 'string', 'html', 'array'. Will be used to determine how description will be rendered.
  - descriptor: string, will be used as button name (if any)
  - name: string, will be used as a modal title (if any)
  - description: data type varies. Will be used to render data inside modal.
  - for array description will be rendered as an unordered list, with properties as follows:
    - label: descriptive, on top of description box
    - content: placed inside the description box

@todo:
  - deprecate button, and replace integrate with ellipsis
  - expand Types, so it can handle more datatype
  - make passing props into this component be able to refer to some local JSON file
  - make style object
*/

import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import LinesEllipsis from 'react-lines-ellipsis'
import Tooltip from 'react-tooltip'

class EllipsisModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      style: { width: '40vw' }
    }
  }

  _toggleModal = (showModal) => {
    this.setState({ showModal })
  }

  _renderField = (description, type, descriptor) => {
    if (description === null || description === '') {
      return <i className='fa fa-eye-slash' />
    } else {
      switch (type) {
        case 'array':
        case 'HTML':
          return (
            <button className='btn btn-secondary' onClick={() => this._toggleModal(true)}>
              <a className='text-center' data-tip={`Click to view ${descriptor}`}><Tooltip /></a>
              <i className='fa fa-eye' /> {descriptor}
            </button>
          )
        case 'string':
          return (
            <span onClick={() => this._toggleModal(true)}>
              <a className='text-center' data-tip={`Click to view ${descriptor}`}>
                <Tooltip />
                <LinesEllipsis
                  text={description}
                  maxLine='1'
                  ellipsis='...'
                  trimRight
                  basedOn='letters'
                />
              </a>
            </span>
          )
        default:
          return null
      }
    }
  }

  _renderModal = (props) => {
    const { type, name, description, descriptor } = this.props
    return (
      <Modal center classNames={{ modal: 'modal-large' }} open={props} onClose={() => this._toggleModal(false)}>
        <section className='section' style={this.state.style}>
          <div className='title-block'>
            <h1 className='title'>{descriptor}</h1>
          </div>
          <div className='form-group'>
            <label className='control-label'>{name}</label>
            {this._renderContent(type, description)}
          </div>
          <div className='text-right'>
            <button className='btn btn-primary mr-2 mt-2' onClick={() => this._toggleModal(false)}>Close</button>
          </div>
        </section>
      </Modal>
    )
  }

  _renderContent = (type, description) => {
    switch (type) {
      case 'string':
        return <textarea readOnly style={{ minHeight: '40vh' }} className='form-control' value={description} />
      case 'HTML':
        return <div dangerouslySetInnerHTML={{ __html: description }} />
      case 'array':
        return (
          <div>
            {
              description.map((item, i) => (
                <ul key={i}>
                  <li>{ item.label || '' } { item.content || '' }</li>
                </ul>
              ))
            }
          </div>
        )
      default:
        return null
    }
  }

  render () {
    const { description, type, descriptor } = this.props
    return (
      <section>
        {this._renderField(description, type, descriptor)}
        {this._renderModal(this.state.showModal)}
      </section>
    )
  }
}

export default connect()(EllipsisModal)



// WEBPACK FOOTER //
// ./src/Components/EllipsisModal.js